export const DRIVER_LICENSE_CATEGORIES = 'kategorie-prawa-jazdy';
